import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import materialEmptyImage from "@/assets/agent-user-detail/material-empty-image.webp";

export const MaterialEmptyImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[materialEmptyImage]}
      {...props}
    />
  );
};

MaterialEmptyImage.displayName = 'MaterialEmptyImage';
